import * as Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector(".ad-modal");
  if (!modal) return;

  const adId = modal.dataset.advertisementId;
  if (!adId) return;

  function buildCookieName(adId) {
    return `ad_modal_suppression_${adId}`;
  }

  function roastAdModalSuppressionCookie(adId, permanent) {
    const cookieName = buildCookieName(adId);
    const value = permanent ? "never" : "later";
    // 有効期限: `次回から表示しない` をチェックした場合は365日間/しなかった場合は7日間
    const expires = permanent ? 365 : 7;
    Cookies.set(cookieName, value, { expires, sameSite: "Lax" });
  }

  // 有効な表示抑制cookieがあれば表示しない
  if (Cookies.get(buildCookieName(adId))) return;

  // モーダルを表示
  modal.showModal();

  // ✗ボタンクリックで閉じる
  const closeButton = modal.querySelector(".ad-modal-close");
  closeButton?.addEventListener("click", () => {
    modal.close();
  });

  // close時にcookieに書き込む
  const doNotShowAgainCheckbox = modal.querySelector(".ad-modal-do-not-show-again");
  modal.addEventListener("close", () => {
    const permanent = doNotShowAgainCheckbox?.checked ?? false;
    roastAdModalSuppressionCookie(adId, permanent);
  });
});

